import { imageUrlBuilder, portableTextSerializer } from '@/utils/helpers';

import BlockContent from '@sanity/block-content-to-react';
import Cta from '@/components/ui/buttons/Cta';
import Image from '@/components/Image';
import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.css';
import { CTAComponent } from '@/types/cmsComponents';

interface FiftyFiftyProps {
  heading?: string;
  content?: Record<string, unknown>[];
  bgColor?: Record<string, unknown>;
  image: Record<string, unknown>;
  bgImage: Record<string, unknown>;
  cta?: CTAComponent;
  textColor?: Record<string, unknown>;
  layout?: string;
}

const FiftyFifty: React.FC<FiftyFiftyProps> = ({
  heading,
  content,
  bgColor,
  bgImage,
  cta,
  image,
  layout = 'left',
  textColor,
}) => {
  const wrapperRef = React.useRef(null);

  React.useEffect(() => {
    if (textColor?.hex) {
      wrapperRef.current.style.setProperty('--fontColor', `${textColor.hex}`);
    }
    if (bgColor?.hex) {
      wrapperRef.current.style.setProperty('--bgColor', `${bgColor.hex}`);
    }
    if (bgImage?.asset) {
      const imgUrlBackground = imageUrlBuilder.image(bgImage.asset).width(1920).auto('format').quality(80).url();
      if (imgUrlBackground) {
        wrapperRef.current.style.setProperty('--bgImage', `url(${imgUrlBackground})`);
      }
    }
  }, [bgColor, textColor, bgImage]);

  return (
    <section className={classnames([styles.fiftyfifty, styles[layout]])} ref={wrapperRef}>
      <div className={styles.imageContainer}>
        {image?.asset && (
          <Image
            className={styles.image}
            image={image as { asset: { _ref: string; _type: string } }}
            width={800}
            alt={heading || ''}
          />
        )}
      </div>
      <div className={styles.content}>
        <h2 className={styles.heading}>{heading}</h2>
        <BlockContent blocks={content} serializers={portableTextSerializer} />
        {cta && cta.title && (
          <Cta to={cta.route} type="link">
            {cta.title}
          </Cta>
        )}
      </div>
    </section>
  );
};

export default FiftyFifty;
